export const environment = {
  production: false,
  api_server: `https://dev-api.smartresponse.org`,
  salesforce_clientId: '3MVG9xOCXq4ID1uFG6_DSt6qbopsLBUP8gGz4Df_Fv6C5pfMhLp1Zsj6iPJ4Mfaq3K2opkShCJAlOU35KAliZ',
  salesforce_api: 'https://na78.salesforce.com/services/data/v56.0/sobjects',
  ga_config: 'UA-37022280-2',
};
